export const SET_API_DATA = 'API/DATA/SET';
export const WAITING_API_RESPONSE = 'API/WAITING_API_RESPONSE';
export const CLEAN_API_DATA = 'API/DATA/CLEAN';
export const EMPTY_API_DATA = 'API/DATA/EMPTY';
export const INIT_DATA = 'API/DATA/INIT_DATA';
